// Customer-facing launch controls. Admin functionality must not depend on these flags.
export const PROBIODELIGHTS_CUSTOMER_LAUNCH_ENABLED =
  process.env.REACT_APP_PROBIODELIGHTS_CUSTOMER_LAUNCH_ENABLED === "true";
